var lib_core = require("lib-core");

var ModelAdderStateMachine = require("./modelAdderStateMachine.js");
var ModelAdderModel = require("./modelAdderModel.js");
var ModelAdderView = require("./modelAdderView.js");
var ModelUploadController = require("./../modelUploader/modelUploadController.js");
var ProcessMessageController = require("ui-extensions").ProcessMessageController;

var ModelAdderController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);

    lib_core.GuiEvents.addEvents({
        MAKE_MODEL_PUBLIC_AND_ADD:              {id: 'model_add_01', name: "MAKE_MODEL_PUBLIC_AND_ADD" } ,
        CANCEL_ADD_MODEL:                       {id: 'model_add_02', name: "CANCEL_ADD_MODEL" },

    });
};

lib_core.inherit(ModelAdderController, lib_core.Controller);
module.exports = ModelAdderController;

ModelAdderController.inject = {
    userController : lib_core.UserController,
    processMessageController : ProcessMessageController,
    modelUploadController: ModelUploadController
};

ModelAdderController.prototype.createView = function () {
    return new ModelAdderView(this.getModel(), this.getStatemachine(), this.root.editorHolder);
};

ModelAdderController.prototype.createModel = function () {
    return new ModelAdderModel(this.root);
};

ModelAdderController.prototype.createStateMachine = function () {
    var userModel = this.userController.getModel();
    return new ModelAdderStateMachine(this.root, this.getModel(), this.getCollection(), userModel, this.root.dataLoader.dataManager, this.modelUploadController.getStatemachine(), this.processMessageController.getModel());
};

ModelAdderController.prototype.getCollection = function () {
    if(this.configuration.collection) {
        return this.root.findByPath(this.configuration.collection);
    }

    return null;
};
